import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import ChangeCredentials from "@/pages/ChangeCredentials";
import Dashboard from "@/pages/Dashboard";
import CardEditor from "@/pages/CardEditor";
import PublicCard from "@/pages/PublicCard";

function Protected({ children, requireSetup = true }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50"><Loader2 className="animate-spin text-indigo-500" size={30} /></div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (requireSetup && user.must_change_credentials) return <Navigate to="/setup" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user && user !== false && !user.must_change_credentials) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/c/:id" element={<PublicCard />} />
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/setup" element={<Protected requireSetup={false}><ChangeCredentials /></Protected>} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/card/new" element={<Protected><CardEditor /></Protected>} />
            <Route path="/card/:id" element={<Protected><CardEditor /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
